//封装操作localStorage本地储存的方法
type IStorage = {
    set: (key: string, value: any) => void;
    get: (key: string) => string | null;
    remove: (key: string) => void;
}
export const storage: IStorage = {
    set(key, value) {
        window.localStorage.setItem(key, value);
    },
    get(key) {
        return window.localStorage.getItem(key);
    },
    remove(key) {
        window.localStorage.removeItem(key);
    }
}